/* eslint-disable jsdoc/require-jsdoc */
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

export const DefaultText = ({ children, ...props }) => (
  <Text
    lineHeight='158%'
    weight='400'
    size='large'
    style={{ display: 'inline' }}
    {...props}
  >
    {children}
  </Text>
);

export const StyledPrerequisites = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3px;
  margin-left: 1rem;
`;

export const CodeText = styled(DefaultText)`
  font-family: 'Courier';
  display: inline;
  background-color: ${getColor('botticelli')};
`;

export const InitialStepWrapper = styled(Flex)`
  margin-left: 12.6rem;
`;

export const StepsWrapper = styled(Flex)`
  margin-left: 1rem;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const PipelineImage = styled.img`
  width: 59rem;
  height: auto;
  border: 1px solid #bdc1c5;
  background-color: #f5f7fa;
  padding: 0.5rem;
  margin: 1rem 0 1.5rem 0;
`;
